<template>
  <div :class="{ 'container-fluid': !newuser, container: newuser }">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="/">Home</a>
        </li>
        <li v-if="!newuser" class="breadcrumb-item">Versões</li>
        <li v-else class="breadcrumb-item">Bem vindo!</li>
      </ol>
    </nav>
    <div v-if="!newuser" class="row">
      <div v-if="versions.length" class="col-lg-3 col-12">
        <div class="card">
          <div class="list-group list-group-flush">
            <button
              type="button"
              v-for="version in versions"
              :key="version.id"
              class="list-group-item list-group-item-action"
              @click="active = version"
              :class="{ active: active.id === version.id }"
            >
              <span>{{ version.nome }}</span>

              <span
                v-if="version.comments_count"
                class="float-right badge badge-pill badge-info ml-1"
                >{{ version.comments_count }}</span
              >
              <span
                v-if="version.aprovada === 0"
                class="float-right badge badge-warning ml-1"
                >Aguardando</span
              >
              <span
                v-else-if="version.aprovada === 1"
                class="float-right badge badge-success ml-1"
                >Aprovada</span
              >
              <span v-else class="float-right badge badge-danger ml-1"
                >Rejeitada</span
              >
              <span
                class="badge float-right"
                :class="{
                  'badge-primary': active.id !== version.id,
                  'badge-light': active.id === version.id,
                }"
                >Versão {{ version.version_number }}</span
              >
            </button>
          </div>
        </div>
        <base-pagination
          class="mt-2"
          v-if="count > limit"
          align="center"
          :total="count"
          :perPage="limit"
          :value="page"
          @input="goToPage($event)"
        ></base-pagination>
      </div>
      <div class="col-lg-9 col-12 row mx-auto mt-2 mt-lg-0">
        <div v-if="active" class="col-12 col-lg-9">
          <div
            class="card"
            :class="{
              'border-success': active.aprovada === 1,
              'border-warning': active.aprovada === 0,
              'border-danger': active.aprovada === 2,
            }"
          >
            <div
              class="card-header"
              :class="{
                'bg-success': active.aprovada === 1,
                'bg-warning': active.aprovada === 0,
                'bg-danger': active.aprovada === 2,
              }"
            >
              <div class="row">
                <h6 class="m-0 font-weight-bold col-7">
                  <router-link
                    class="text-light"
                    :to="{ name: 'Arvore', params: { id: active.id_pessoa } }"
                    >{{ active.nome }}</router-link
                  >
                </h6>
              </div>
            </div>
            <version :version="active" :detailed="true" />
          </div>
        </div>
        <div class="col-12 col-lg-9" v-if="!versions.length && carregado">
          <div class="alert alert-success" role="alert" v-if="!viewer">
            <h4 class="alert-heading">Bem vindo!</h4>
            <p>Agora você é um editor do Genealogia Bíblica!</p>
            <p>
              Para começar você pode
              <router-link :to="{ name: 'edit' }" class="mr-1"
                >adicionar algum personagem</router-link
              >da Bíblia que não tenha achado em nossa base de dados, ou editar
              um já existente! Procure algum nome que deseja editar e você verá
              o botão de Editar.
            </p>
            <div class="text-center">
              <form-search
                class="d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search"
              />
            </div>
            <hr />
            <p class="mb-0">
              <strong>Não se preocupe!</strong> As edições que você fizer
              passarão por uma avaliação antes de irem para o ar no site. 😉
            </p>
          </div>
          <nenhum-registro />
        </div>
        <div class="col-lg-3 col-12 mt-2 mt-lg-0">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <h6 class="m-0 font-weight-bold text-primary col-7">Ações</h6>
              </div>
            </div>
            <div class="card-body">
              <template v-if="active">
                <router-link
                  v-if="active.inicio"
                  class="btn btn-primary btn-block"
                  :to="{
                    name: 'Timeline',
                    hash: `#pessoa-${active.id_pessoa}`,
                  }"
                  ><i class="fas fa-clock fa-sm fa-fw text-gray-400"></i> Linha
                  do tempo</router-link
                >
                <router-link
                  class="btn btn-primary btn-block"
                  :to="{ name: 'edit', params: { id: active.id_pessoa } }"
                >
                  <i class="fas fa-edit mr-1"></i>
                  <span>Editar {{ active.nome }}</span>
                </router-link>
                <router-link
                  class="btn btn-secondary btn-block"
                  v-if="!id"
                  :to="{ name: 'dashboard', params: { id: active.id_pessoa } }"
                >
                  <i class="fas fa-code-branch"></i>
                  Versões de {{ active.nome }}
                </router-link>
              </template>
              <router-link
                class="btn btn-secondary btn-block"
                v-if="id || !active"
                :to="{ name: 'dashboard' }"
              >
                <i class="fas fa-code-branch"></i> Versões
              </router-link>
              <router-link
                v-if="!viewer"
                class="btn btn-success btn-block"
                :to="{ name: 'edit' }"
              >
                <i class="fas fa-plus"></i> Adicionar Pessoa
              </router-link>
              <template v-if="admin && active">
                <button
                  class="btn btn-outline-success btn-block"
                  @click="trocarStatusAprovacao(1)"
                  v-if="active.aprovada !== 1"
                >
                  <i class="fas fa-check mr-1"></i>
                  <span>Aprovar</span>
                </button>
                <button
                  class="btn btn-outline-danger btn-block"
                  @click="trocarStatusAprovacao(2)"
                  v-if="active.aprovada !== 2"
                >
                  <i class="fas fa-times mr-1"></i>
                  <span>Rejeitar</span>
                </button>
                <button
                  class="btn btn-outline-warning btn-block"
                  @click="trocarStatusAprovacao(0)"
                  v-if="active.aprovada !== 0"
                >
                  <i class="fas fa-clock mr-1"></i>
                  <span>Deixar Aguardando</span>
                </button>
              </template>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="active">
          <comments
            @add="commentAdded($event)"
            :comments="active.comments"
            class="mt-2"
            :id="active.id"
          />
        </div>
      </div>
    </div>
    <welcome v-else />
  </div>
</template>
<script>
import FormSearch from "@/components/FormSearch";
import { getVersions, edit } from "@/services/version-service";
import BasePagination from "@/components/BasePagination";
import Comments from "@/components/Comments";
import Version from "@/components/Version";
import Welcome from "@/components/Welcome";
import NenhumRegistro from "@/components/NenhumRegistro";

export default {
  components: {
    Welcome,
    BasePagination,
    Version,
    Comments,
    NenhumRegistro,
    FormSearch,
  },
  data() {
    return {
      limit: 10,
      page: 1,
      count: 0,
      versions: [],
      active: undefined,
      carregado: false,
    };
  },

  computed: {
    admin() {
      return this.$store.state.user.role === "admin" ? 1 : 0;
    },
    id() {
      return this.$route.params.id;
    },
    viewer() {
      return this.$store.state.user.role === "viewer";
    },
    newuser() {
      return this.$store.state.user.status === 0;
    },
  },

  watch: {
    $route(depois, antes) {
      if (
        depois.query.page === antes.query.page &&
        depois.params.id !== antes.params.id
      ) {
        this.active = undefined;
      }

      this.loadData();
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    commentAdded(data) {
      this.active.comments_count = data;
    },

    async trocarStatusAprovacao(status) {
      const formData = {
        aprovada: status,
      };

      this.$store.dispatch("showOverlay", true);

      try {
        await edit(this.active.id, formData);

        this.active = Object.assign(this.active, formData);
      } catch (error) {
        this.$notify("Erro ao editar versão", "error");
      } finally {
        this.$store.dispatch("showOverlay", false);
      }
    },

    goToPage(page) {
      this.$router.push({
        name: "dashboard",
        query: { page: page },
        params: { id: this.id },
      });
    },

    async loadData() {
      this.page = parseInt(this.$route.query.page) || 1;
      this.carregado = false;
      this.versions = [];

      const filter = {
        limit: this.limit,
        page: this.page,
        admin: this.admin,
        "orderBy[]": "id,desc",
      };

      if (this.$route.params.id) {
        filter.person = this.$route.params.id;
      }

      this.$store.dispatch("showOverlay", true);

      try {
        const { data } = await getVersions(filter);
        this.versions = data.data;
        this.count = data.total;

        if (!this.active) {
          this.active = this.versions[0];
        }
      } catch (error) {
        this.$notify("Erro ao carregar busca", "error");
      } finally {
        this.carregado = true;
        this.$store.dispatch("showOverlay", false);
      }
    },
  },
};
</script>
